import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=6c6d3aca&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports